import {Component, Inject, OnInit} from '@angular/core';
import {CasinoBetsService} from "../../../services/casino/casino-bets.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {UserService} from "../../../services/user.service";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-poker-oneday',
    templateUrl: './poker-oneday.component.html',
    styleUrls: ['./poker-oneday.component.css']
})
export class PokerOnedayResultComponent implements OnInit {
    details: any = {};
    player1: any = [];
    player2: any = [];
    tables: any = [];
    winner: any = '';
    cards: any = '';
    casino_bets: any = [];
    filter_bets: any = [];
    totalbets: number = 0;
    totalAmount: number = 0;
    cards2ABonus: string = "";
    cards7ABonus: string = "";
    cards2BBonus: string = "";
    cards7BBonus: string = "";

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private casinoBetsService: CasinoBetsService, private router: Router, public dialogRef: MatDialogRef<any>, private fb: FormBuilder, private userService: UserService, private toasterService: ToastrService) {

    }

    ngOnInit(): void {
        console.log('poker oneday')
        this.dialogRef.updateSize('100%',);
        if(!this.data.acc_state){
            this.getPokerOneDayDetails();
            }else{
              this.getCasinoResultonMarketId();
            }
        this.getCasinoBetsByMarketID();
    }

    getCasinoResultonMarketId(){
        this.casinoBetsService.getCasinoResultonMarketId(this.data.mid).subscribe((res:any)=>{
          if(res.length>0){
          const renamedObject = {
            ...res[0],          // Copy all existing properties
            desc: res[0].description, // Rename description to desc
            cards: res[0].result // Rename result to cards
          };
          console.log("renamedObject",renamedObject);
          this.extractResultFromData(renamedObject)
        }
        })
      }

    getPokerOneDayDetails() {
        this.casinoBetsService.getTeenPattiDetails(this.data.mid).subscribe((res: any) => {
            if (res.success) {
                this.details = res.data;
                console.log('xxx--------->', this.details);
                this.getResults(this.details[0]);
                this.extractResultFromData(this.details[0])

            }
        });
    }

    private getResults(data: any) {
        const [player1, player2, tables] = this.divideIntoArrays(data.cards);
        this.player1 = player1;
        this.player2 = player2;
        this.tables = tables;
        this.winner = data.win;
        this.cards = this.getFirstCharacters(data.cards);
    }

    private divideIntoArrays(playerString: string) {
        // Split the string by comma
        const players = playerString.split(",");

        // Initialize empty arrays
        const player1 = [];
        const player2 = [];
        const tables = [];

        // Loop through players, assigning first two to player1, second two to player2, and remaining to table
        for (let i = 0; i < players.length; i++) {
            if (i < 2) {
                player1.push(players[i]);
            } else if (i < 4) {
                player2.push(players[i]);
            } else {
                tables.push(players[i]);
            }
        }

        // Return an object containing the arrays
        return [player1, player2, tables];
    }

    private getFirstCharacters(inputString: string) {
        const gameArray = inputString.split(',');
        const result = gameArray.map(game => game.charAt(0));
        return result.join(' ');
    }

    getCasinoBetsByMarketID() {
        this.casinoBetsService.getCasinoBetsByOnlyMarketId(this.data.mid).subscribe((res: any) => {
            console.log('filter_bets data', res);
            this.casino_bets = res;
            this.filter_bets = this.casino_bets;
            this.totalbets = this.casino_bets.length;
            this.totalAmount = this.casino_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
        });
    }

    private extractResultFromData(result: any) {
        let card2_bonus_win = [];
        let card7_bonus_win = [];
        let main_winner;
        let pokerfancy_win = [];
        // let result = {cards: "9HH,9CC,8SS,6CC,5HH,2HH,10CC,KSS,6HH", desc: "Player A##Pair, 9 ##Pair, 6 "}
        if (result.cards.length > 0 && result.desc.length > 0) {
            //---------------------------- 2 card bonus logic---------------------------------------
            const cards = result.cards;
            const cardArray = cards.split(",");
            const playerA = [cardArray[0], cardArray[1]];
            const playerB = [cardArray[2], cardArray[3]];

            function getCardDetails(card: any) {
                return {
                    rank: card.slice(0, -2),
                    suit: card.slice(-2),
                };
            }

            function checkCombinations(playerCards: any) {
                const [card1, card2] = playerCards.map(getCardDetails);
                const combinations: any = {};

                combinations.Pair2to10 =
                    card1.rank === card2.rank &&
                    parseInt(card1.rank) >= 2 &&
                    parseInt(card1.rank) <= 10;
                combinations.AQorAJOffSuited =
                    (card1.rank === "A" &&
                        (card2.rank === "Q" || card2.rank === "J") &&
                        card1.suit !== card2.suit) ||
                    (card2.rank === "A" &&
                        (card1.rank === "Q" || card1.rank === "J") &&
                        card1.suit !== card2.suit);
                combinations.PairJQK =
                    card1.rank === card2.rank &&
                    (card1.rank === "J" || card1.rank === "Q" || card1.rank === "K");
                combinations.AKoffSuited =
                    (card1.rank === "A" &&
                        card2.rank === "K" &&
                        card1.suit !== card2.suit) ||
                    (card2.rank === "A" &&
                        card1.rank === "K" &&
                        card1.suit !== card2.suit);
                combinations.AQorAJSuited =
                    (card1.rank === "A" &&
                        (card2.rank === "Q" || card2.rank === "J") &&
                        card1.suit === card2.suit) ||
                    (card2.rank === "A" &&
                        (card1.rank === "Q" || card1.rank === "J") &&
                        card1.suit === card2.suit);
                combinations.AKSuited =
                    (card1.rank === "A" &&
                        card2.rank === "K" &&
                        card1.suit === card2.suit) ||
                    (card2.rank === "A" &&
                        card1.rank === "K" &&
                        card1.suit === card2.suit);
                combinations.aa = card1.rank === "A" && card2.rank === "A";

                return Object.fromEntries(
                    Object.entries(combinations).filter(([key, value]) => value)
                );
            }

            const playerACombinations = checkCombinations(playerA);
            const playerBCombinations = checkCombinations(playerB);

            if (Object.keys(playerACombinations).length > 0) {
                card2_bonus_win.push("Player A 2 card Bonus");
            }
            if (Object.keys(playerBCombinations).length > 0) {
                card2_bonus_win.push("Player B 2 card Bonus");
            }


            //---------------------------- 7 card bonus logic---------------------------------------
            const parts = result.desc.split("##");
            main_winner = parts[0];
            const bonusA = parts[1];
            const bonusB = parts[2];

            // List of possible hands
            const hands = [
                "Three of a Kind",
                "Straight",
                "Flush",
                "Full House",
                "Four of a Kind",
                "Straight Flush",
                "Royal Flush",
            ];

            // Function to extract hands included in the bonus string
            function extractHands(bonus: any) {
                return hands.filter((hand) => bonus.includes(hand));
            }

            // Extract hands for 7 card bonus A and B
            const playerAHands = extractHands(bonusA);
            const playerBHands = extractHands(bonusB);


            const playerAWinningCombinations = Object.keys(playerACombinations).filter(
                (key) => playerACombinations[key]
            );
            const playerBWinningCombinations = Object.keys(playerBCombinations).filter(
                (key) => playerBCombinations[key]
            );
            this.cards2ABonus = playerAWinningCombinations.join(",");
            this.cards2BBonus = playerBWinningCombinations.join(",");
            this.cards7ABonus = playerAHands.join(",");
            this.cards7BBonus = playerBHands.join(",");

            console.log("Player A 2 cards:", playerAWinningCombinations);
            console.log("Player B 2 cards:", playerBWinningCombinations);
            console.log("Player A 7 Card Hands:", playerAHands);
            console.log("Player B 7 Card Hands:", playerBHands);

        }
    }


    filterBetsByType(event: any) {
        const filterType = (event.target as HTMLInputElement).value;
        console.log('filterType', filterType);
        if (filterType === 'all') {
            this.filter_bets = this.casino_bets;
        } else if (filterType === 'deleted') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.from === "deleted");
        } else if (filterType === 'Back') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Back");
        }
        if (filterType === 'Lay') {
            this.filter_bets = this.casino_bets.filter((bet: any) => bet.type === "Lay");
        }
        this.totalbets = this.filter_bets.length;
        this.totalAmount = this.filter_bets.reduce((sum: any, entry: any) => sum + (entry.profit_loss || 0), 0);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    dismiss() {
        this.dialogRef.close();
    }

}
